import L from "leaflet";

import { ILocationInfo } from "../Features/LocationInfo/types";

export function geolocationPositionToLocation(position: GeolocationPosition): ILocationInfo {   
    return {
        point: L.latLng(position.coords.latitude, position.coords.longitude),
        altitudeMetres: position.coords.altitude,
        speedMetresPerSec: position.coords.speed,
        headingDegrees: position.coords.heading
    };
}

const locationHeadingThresholdKmh = 2;
const locationHeadingThresholdMetresPerSec = locationHeadingThresholdKmh * 3.6;

export function resolveCompassHeadingDegress(deviceHeadingDegrees: number | null, location: ILocationInfo | null): number  | null {

    if (!location || !location.speedMetresPerSec)
        return deviceHeadingDegrees;

    if (location.speedMetresPerSec >= locationHeadingThresholdMetresPerSec)
        return location?.headingDegrees ?? deviceHeadingDegrees;

    return deviceHeadingDegrees;
};

